const mainHideClass = "hide-this";

export const hideDomElement = (domElement) => {
    if (!domElement) return;
    domElement.classList.add(mainHideClass);
}

export const showDomElement = (domElement) => {
    if (!domElement) return;
    domElement.classList.remove(mainHideClass);
}
